import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TermsComponent } from './terms.component';

@NgModule({
  declarations: [TermsComponent],
  exports: [TermsComponent],
  imports: [CommonModule, RouterModule],
})
export class TermsModule {}
